import React from "react";

const StudentResellerHome = () => {
  return (
    <div className="min-h-screen bg-[#F1F3F2] px-4 py-8 text-gray-900">
      <div className="mx-auto max-w-xl rounded-2xl bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-gray-900">Student Reseller</h1>
        <p className="mt-3 text-sm text-gray-600">
          Your student reseller account is ready.
        </p>
      </div>
    </div>
  );
};

export default StudentResellerHome;
